import { ReactNode } from "react";
import styled from "styled-components";
import _css from "@styled-system/css";
import {
  color,
  layout,
  LayoutProps,
  typography,
  TypographyProps,
  space,
  SpaceProps,
} from "styled-system";

type StyledParagraphProps = LayoutProps &
  TypographyProps &
  SpaceProps & {
    css?: string;
    color?: string;
    children: ReactNode;
    textAlign: "left" | "center" | "right";
  };

const StyledParagraph = styled.p<Partial<StyledParagraphProps>>`
  line-height: 19px;
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
  ${_css({
    fontSize: "body",
    fontWeight: "normal",
    fontFamily: "normal",
  })}
  ${color}
    ${layout}
    ${typography}
    ${space}
    ${(props) => props.css}
`;

export default function Paragraph({
  children,
  color = "lighter-text-color",
  ...props
}: StyledParagraphProps) {
  return (
    <StyledParagraph color={color} {...props}>
      {children}
    </StyledParagraph>
  );
}
